import React from 'react'
// import PropTypes from 'prop-types'

import Logos from './Logos'

import styles from './Text.module.css'

export default function Text () {
  return (
    <div className={styles.root}>
      <div className={styles.payments}>
        <h4>
          Возврат денежных средств
        </h4>

        <p>
          Для возврата средств плательщику необходимо <a href="/refund.doc">заполните заявление по форме</a>, подписать его собственноручно и направить на почту <a href="mailto:oplata@lunn.ru">oplata@lunn.ru</a>:
        </p>

        <ul className={styles.ul}>
          <li>
            отсканированную копию заявления;
          </li>

          <li>
            отсканированную копию первой страницы паспорта;
          </li>

          <li>
            реквизиты счета для перевода, выданные банком.
          </li>
        </ul>

        <p>
          Возврат денежных средств будет произведен после проверки и идентификации плательщика в течение 15 рабочих дней с момента предоставления документов на возврат.
        </p>

        <p>
          Обращаем ваше внимание на то, что оплаченные средства наличными не выплачиваются, возврат денег осуществляется банковским переводом на карту клиента, оплатившего услугу.
        </p>

        <p className={styles.contacts}>
          По вопросам оплаты или возврата можно связаться по телефону +7 (831) 436-00-26 или по почте <a href="mailto:oplata@lunn.ru">oplata@lunn.ru</a>
        </p>
      </div>

      <div>
        <Logos />
      </div>

      <div className={styles.security}>
        Безопасность платежей обеспечивается с помощью Банка-эквайера (Газпромбанк (Акционерное Общество)), функционирующего на основе современных протоколов и технологий, разработанных платежными системами МИР, Visa International и Mastercard Worldwide (3D-Secure: Verified by VISA, Mastercard SecureCode, MirAccept). Обработка полученных конфиденциальных данных Держателя карты производится в процессинговом центре Банка, сертифицированного по стандарту PCI DSS. Безопасность передаваемой информации обеспечивается с помощью современных протоколов обеспечения безопасности в сети Интернет.
      </div>
    </div>
  )
}
